module.exports = __webpack_public_path__ + "img/es.es36cdd00.svg";